// eslint-disable-next-line unused-imports/no-unused-vars
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const doNothing = (...args: any) => {
	// does nothing, intentionally empty
}; //NOSONAR

type IFunction<A = any[], B = any> = (...args: A extends any[] ? A : [A]) => B;
type Nullable<T> = T | null;

const events: { [event: string]: IFunction[] } = {};

const onEvent = (event: string, handler: IFunction): void => {
	if (events[event]) {
		events[event].push(handler);
	} else {
		events[event] = [handler];
	}
};

const offEvent = (event: string, handler?: IFunction): void => {
	if (events[event]) {
		if (handler) {
			const { length } = events[event];

			for (let i: number = 0; i < length; i++) {
				if (events[event][i] === handler) {
					events[event].splice(i, 1);

					return;
				}
			}
		} else {
			events[event].splice(0);
			delete events[event];
		}
	}
};

const emitEvent = <T = any>(event: string, ...args: T[]): void => {
	if (events[event]) {
		for (const handler of events[event]) {
			handler(...args);
		}
	}
};

const request = <T = unknown>(event: string, ...args: unknown[]): T[] | T | null => {
	const handlers = events[event];

	if (handlers?.length) {
		if (handlers.length > 1) {
			return handlers.map((handler) => handler(...args));
		}

		return handlers[0](...args);
	}

	return null;
};

const asyncRequest = async <T = unknown>(
	event: string,
	...args: unknown[]
): Promise<Nullable<T>[] | T | null> => {
	const handlers = events[event];

	try {
		if (handlers) {
			const { length } = handlers;

			if (handlers.length > 1) {
				const responses: Nullable<T>[] = [];

				for (let h: number = 0; h < length; h++) {
					responses[h] = await handlers[h](...args);
				}

				return responses;
			} else {
				return await handlers[0](...args);
			}
		}
	} catch (err) {
		doNothing(err);
	}

	return null;
};

export const globalEvents = {
	on: onEvent,
	off: offEvent,
	emit: emitEvent,
	request,
	asyncRequest,
};

export interface IGlobalEvents {
	on: typeof onEvent;
	off: typeof offEvent;
	emit: typeof emitEvent;
	request: typeof request;
	asyncRequest: typeof asyncRequest;
}

export const emitMaker = (event: string, ...args: any[]) => {
	const fn = () => {
		globalEvents.emit(event, ...args);
	};

	return fn;
};
